import React, { useRef, useEffect, useState, useLayoutEffect } from 'react';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import moment from 'moment';
import { Card, Empty, Select } from 'antd';

am4core.useTheme(am4themes_animated);

const transformFiledToLabel = (fieldName) => {
    return fieldName.replace('_', ' ')
}

function MovementChart({ data: docs, idleFuelRate, selectedGroup,
    assetData, standardFuelRate, deviceData, isShowDeviceData,
    processDataWithGroups,
    chartUnit = 'hours', loading, ...props }) {

    const [data, setData] = useState([]);
    const [rateTypeField, setRateTypeField] = useState('hours_consumed');
    // const [rateTypeFieldReverse, setRateTypeFieldReverse] = useState('kms_consumed');

    const [header, setHeader] = useState('--');
    const [standardRateHour, setStandardRateHour] = useState(0);
    const [standardRateKm, setStandardRateKm] = useState(0);

    // const [deviceBasedData, setDeviceBasedData] = useState(null)

    // useEffect(() => {
    //     setData(docs)
    // }, [docs]);

    useEffect(() => {
        // console.log(deviceData, docs);
        if (isShowDeviceData && docs && docs.length && deviceData && deviceData.length) {

            const arr = deviceData.concat(docs);
            const map = new Map();
            // console.log(arr);

            arr.forEach(d => {
                if (!map.has(d.date)) {
                    const ix = docs.findIndex(i => i.date === d.date)
                    const ixd = deviceData.findIndex(i => i.date === d.date)
                    map.set(d.date, {
                        date: d.date,
                        hours_consumed: ix >= 0 ? docs[ix]['hours_consumed'] : 0,
                        kms_consumed: ix >= 0 ? docs[ix]['kms_consumed'] : 0,
                        distance_travelled: ixd >= 0 ? deviceData[ixd]['distance_travelled'] : 0,
                        moving_time: ixd >= 0 ? (Number(deviceData[ixd].moving_time_min || '0') / 60).toFixed(2) : 0,
                        idle_time: ixd >= 0 ? (Number(deviceData[ixd].idle_time_min || '0') / 60).toFixed(2) : 0,
                    });
                }
            })

            const newDocs = Array.from(map.values());


            // (deviceData || []).forEach(d => {
            //     const ix = docs.findIndex(i => i.date === d.date)
            //     if (ix >= 0) {
            //         docs[ix]['distance_travelled'] = d.distance_travelled || 0
            //         docs[ix]['moving_time'] = (Number(d.moving_time_min || '0') / 60).toFixed(2) || 0
            //         docs[ix]['idle_time'] = (Number(d.idle_time_min || '0') / 60).toFixed(2) || 0
            //     }
            // })
            // console.log(selectedGroup, newDocs);
            const group = processDataWithGroups(newDocs, selectedGroup)
            // console.log(group);
            setData(group)
        } else {
            // console.log(selectedGroup);
            const group = processDataWithGroups(docs, selectedGroup)
            // console.log(group);
            setData(group)
        }
        // setDeviceBasedData(deviceData)
    }, [deviceData, isShowDeviceData, docs, selectedGroup]);

    // useEffect(() => {
    //     console.log(selectedGroup);
    //     const group = processDataWithGroups(data, selectedGroup)
    //     console.log(group);
    //     // setData(group)
    // }, [data])

    useLayoutEffect(() => {
        if (chartUnit === 'hours') {
            setRateTypeField('hours_consumed')
        } else {
            setRateTypeField('kms_consumed')
        }
    }, [chartUnit]);



    // useEffect(() => {
    //     console.log(data);
    // }, [data])

    useLayoutEffect(() => {
        if (selectedGroup && assetData && chartUnit) {
            const title = selectedGroup === 'w' ? 'Weekly' : selectedGroup === 'm' ? 'Monthwise' : selectedGroup === 'y' ? 'Yearwise' : 'Daywise';
            // setHeader(`${title} Consumption rate (mileage) for ${assetData.assetCode}`)
            setHeader(`${title} ${chartUnit.toLocaleUpperCase()} consumption chart for asset ${assetData.assetCode}`)
        }
    }, [selectedGroup, assetData, chartUnit]);

    useEffect(() => {
        if (standardFuelRate && standardFuelRate.length) {
            const hrRate = standardFuelRate.filter(s => (s.perType && s.perType.name && s.perType.name === 'HOURS'))
            if (hrRate && hrRate[0] && hrRate[0]['fuelQty'])
                setStandardRateHour(hrRate[0]['fuelQty'])
            const kmRate = standardFuelRate.filter(s => (s.perType && s.perType.name && s.perType.name === 'KMS'))
            if (kmRate && kmRate[0] && kmRate[0]['fuelQty'])
                setStandardRateKm(kmRate[0]['fuelQty'])
        }
    }, [standardFuelRate]);

    // useLayoutEffect(() => {
    //     if (assetData) {
    //         setHeader(`Daywise ${chartUnit.toLocaleUpperCase()} Movement chart for asset ${assetData.assetCode}`)
    //     }
    // }, [assetData, chartUnit])

    const chart = useRef(null);

    useLayoutEffect(() => {
        if (!loading && data && data.length) {

            let totalConsumptionRate = 0;
            data.forEach(d => {
                totalConsumptionRate += Number(d[rateTypeField])
            })

            let x = am4core.create("movementConsumed", am4charts.XYChart);
            // am4core.addLicense("ch-custom-attribution");

            let title = x.titles.create();
            title.text = header || '';
            title.fontSize = 15;
            title.marginBottom = 18;

            // Export
            x.exporting.menu = new am4core.ExportMenu();
            x.exporting.filePrefix = "fuel_consumption_rate_time" + new Date().getTime();;

            x.paddingRight = 20;

            let dateAxis = x.xAxes.push(new am4charts.CategoryAxis());
            dateAxis.dataFields.category = "date";
            dateAxis.title.text = selectedGroup === 'm' ? 'Month' : selectedGroup === 'w' ? 'Week' : selectedGroup === 'y' ? 'Year' : 'Date Range';
            // Format the labels
            // dateAxis.renderer.labels.template.adapter.add("text", function (label, target, key) {
            //     console.log(label, target, key);
            //     return label;
            //     // return moment(label).format('MM-DD');
            // });
            // dateAxis.title.text = "Date(DD-MM)"
            // categoryAxis.renderer.minGridDistance = 30;
            // dateAxis.renderer.labels.template.rotation = -90;

            let valueAxis = x.yAxes.push(new am4charts.ValueAxis());
            valueAxis.title.text = `Consumption (${transformFiledToLabel(rateTypeField)})`
            valueAxis.renderer.line.strokeOpacity = 1;
            valueAxis.renderer.line.strokeWidth = 2;
            valueAxis.renderer.line.stroke = am4core.color("#717d7e");
            valueAxis.renderer.labels.template.fill = am4core.color("#717d7e");

            if (isShowDeviceData) {

                let deviceValueAxis = x.yAxes.push(new am4charts.ValueAxis());
                deviceValueAxis.title.text = chartUnit === 'kms' ? 'Distance Travelled - IOT (KMs)' : 'Time Taken - IOT (Hrs.)'
                deviceValueAxis.renderer.line.strokeOpacity = 1;
                deviceValueAxis.renderer.line.strokeWidth = 2;
                deviceValueAxis.renderer.line.stroke = am4core.color("#3D85C6");
                deviceValueAxis.renderer.labels.template.fill = am4core.color("#3D85C6");

                let deviceLineSeries = x.series.push(new am4charts.LineSeries());
                deviceLineSeries.name = chartUnit === 'kms' ? "Kms (IOT)" : "Hours (IOT)";
                deviceLineSeries.dataFields.valueY = chartUnit === 'kms' ? "distance_travelled" : "moving_time";
                deviceLineSeries.dataFields.categoryX = "date";
                deviceLineSeries.strokeWidth = 2;
                deviceLineSeries.propertyFields.strokeDasharray = "lineDash";
                deviceLineSeries.tooltip.label.textAlign = "middle";
                deviceLineSeries.yAxis = deviceValueAxis;
                deviceLineSeries.stroke = am4core.color("#3D85C6");
                // deviceLineSeries.legendSettings.labelText = `Distance. (Total: ${totaldistance_travelled.toFixed(2)} Kms.)`;

                let deviceBullet = deviceLineSeries.bullets.push(new am4charts.Bullet());
                deviceBullet.fill = am4core.color("#fff"); // tooltips grab fill from parent by default
                deviceBullet.tooltipText = "[#3D85C6 font-size: 11px]{name} in {dateX}:\n[/][#3D85C6 font-size: 15px]{valueY}[/] [#3D85C6]{additional}[/]"
                let deviceCircle = deviceBullet.createChild(am4core.Circle);
                deviceCircle.radius = 2;
                deviceCircle.fill = am4core.color("#fff");
                deviceCircle.strokeWidth = 1;
            }

            if (chartUnit === 'kms' && standardRateKm) {
                let averageGuide = valueAxis.axisRanges.create();
                averageGuide.value = (1 / standardRateKm).toFixed(2);
                averageGuide.grid.stroke = am4core.color("#000");
                averageGuide.grid.strokeWidth = 1.5;
                averageGuide.grid.strokeOpacity = 0.7;
                averageGuide.grid.strokeDasharray = "4,4";
                // averageGuide.label.text = `${(1 / standardRateKm).toFixed(2)}`;
                // averageGuide.label.align = "right";
                // averageGuide.label.verticalCenter = "bottom";
            } else if (chartUnit === 'hours' && standardRateHour) {
                let averageGuide = valueAxis.axisRanges.create();
                averageGuide.value = (1 / standardRateHour).toFixed(2);
                averageGuide.grid.stroke = am4core.color("#000");
                averageGuide.grid.strokeWidth = 1.5;
                averageGuide.grid.strokeOpacity = 0.7;
                averageGuide.grid.strokeDasharray = "4,4";
                // averageGuide.label.text = `${(1 / standardRateHour).toFixed(2)}`;
                // averageGuide.label.align = "right";
                // averageGuide.label.verticalCenter = "bottom";
            }

            let lineSeries = x.series.push(new am4charts.LineSeries());
            lineSeries.name = `${transformFiledToLabel(rateTypeField)}`;
            lineSeries.dataFields.valueY = rateTypeField;
            lineSeries.dataFields.categoryX = "date";
            lineSeries.strokeWidth = 2;
            lineSeries.propertyFields.strokeDasharray = "lineDash";
            lineSeries.tooltip.label.textAlign = "middle";
            lineSeries.yAxis = valueAxis;
            lineSeries.stroke = am4core.color("#717d7e");
            // lineSeries.legendSettings.labelText = `Distance. (Total: ${totaldistance_travelled.toFixed(2)} Kms.)`;

            let bullet = lineSeries.bullets.push(new am4charts.Bullet());
            bullet.fill = am4core.color("#fff"); // tooltips grab fill from parent by default
            bullet.tooltipText = "[#717d7e font-size: 11px]{name} in {dateX}:\n[/][#717d7e font-size: 15px]{valueY}[/] [#717d7e]{additional}[/]"
            let circle = bullet.createChild(am4core.Circle);
            circle.radius = 2;
            circle.fill = am4core.color("#fff");
            circle.strokeWidth = 1;

            x.legend = new am4charts.Legend();

            // Add cursor
            x.cursor = new am4charts.XYCursor();
            x.cursor.fullWidthLineX = true;
            x.cursor.xAxis = dateAxis;
            x.cursor.lineX.strokeOpacity = 0;
            x.cursor.lineX.fill = am4core.color("#000");
            x.cursor.lineX.fillOpacity = 0.1;

            // Add scrollbar
            if (data && data.length > 25) {
                let scrollbarX = new am4charts.XYChartScrollbar();
                scrollbarX.series.push(lineSeries);
                // scrollbarX.marginBottom = 50;
                x.scrollbarX = scrollbarX;
            }

            x.cursor = new am4charts.XYCursor();

            x.data = data;

            chart.current = x;

            return () => {
                if (x)
                    x.dispose();
            };
        }
    }, [data, header, rateTypeField, isShowDeviceData]);

    useLayoutEffect(() => {
        if (chart && chart.current)
            chart.current.paddingRight = props.paddingRight;
    }, [props.paddingRight]);

    return <Card>{loading ? (
        <div style={{ width: "100%", height: "500px", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            Loading ...
        </div>
    ) : data && data.length ? (
        <div id="movementConsumed" style={{ width: "100%", height: "500px" }} />
    ) : (
        <div style={{ width: "100%", height: "500px", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Empty />
        </div>
    )}</Card>
}

export default MovementChart;